import React, { useEffect, useState } from "react";
import styles from "./ModalStyle.module.scss";
import close from "../../assets/icons/closeModal.svg";
import facebook from "../../assets/icons/Facebook.svg";
import google from "../../assets/icons/google.svg";
import {
  login,
  register,
  sendGoogleToken,
  setUserCredentials,
  setUserFromStorage,
} from "../../redux/slices/authSlice";
import { Snackbar, SnackbarCloseReason } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { signInWithPopup } from "firebase/auth";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { auth, provider } from "../../firebaseConfig";
import { getLangFromPath } from "../../utils/getLangFromPath ";
import { useTranslation } from "react-i18next";
const LoginModal = ({ handleClose, handleVerify }) => {
  const [registired, setRegistered] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const dispatch = useDispatch();
  const [openedSnackbar, setOpenedSnackbar] = useState(false);

  const status = useSelector((state) => state.authSlice.status);
  // const handleAuthForm = async (e) => {
  //   e.preventDefault();
  //   if (!registired) {
  //     if (password.length < 8) {
  //       setErrorMsg("The length must be between 8 and 255");
  //     }
  //     if (password !== confirmPassword) {
  //       setErrorMsg("Password does not match");
  //     }
  //   }
  //   try {
  //     const response = await dispatch(
  //       registired ? login({ email, password }) : register({ email })
  //     );
  //     if (response.error) {
  //       console.log(response);
  //       setErrorMsg("Login failed: " + response.error.message);
  //     } else {
  //       registired
  //         ? (dispatch(
  //             setUserCredentials({
  //               user: response?.data?.user,
  //               token: response?.data?.token,
  //             })
  //           ) && handleClose())
  //         : handleVerify(email, password, confirmPassword);
  //       setErrorMsg("");
  //     }
  //   } catch (error) {
  //     setErrorMsg("Failed, please try again.");
  //   }
  // };
  const handleAuthForm = async (e) => {
    e.preventDefault();

    if (!registired) {
      if (password.length < 8) {
        return setErrorMsg(
          "The password length must be between 8 and 255 characters."
        );
      }
      if (password !== confirmPassword) {
        return setErrorMsg("Password does not match.");
      }
    }

    try {
      const response = await dispatch(
        registired ? login({ email, password }) : register({ email })
      ).unwrap(); // Use unwrap to handle the response directly

      if (!response || response.error) {
        setErrorMsg(`Failed: ${response?.error?.message || "Unknown error"}`);
        return;
      }

      if (registired) {
        dispatch(
          setUserCredentials({
            user: response?.user, // Assuming response contains user data
            token: response?.token, // Assuming response contains token
          })
        );
        handleClose(); // Close modal if login succeeds
      } else {
        handleVerify(email, password, confirmPassword);
      }

      setErrorMsg("");
    } catch (error) {
      setErrorMsg("An error occurred. Please try again.");
    }
  };

  const handleForgetPassword = async (e) => {
    e.preventDefault();
    setForgetPasswordModal(true);
    const lang = getLangFromPath();
    const response = await axios.post(
      "https://eliteluxora.vps.webdock.cloud/api/auth/forgot-password",
      { email },
      {
        headers: {
          "Accept-Language": lang,
        },
      }
    );
    setOpenedSnackbar(true);
  };
  // const handleGoogleLogin = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;
  //     user && handleClose();
  //     const idToken = await user.getIdToken();

  //     dispatch(setUserCredentials({ user, token: idToken }));
  //     dispatch(sendGoogleToken({ token: idToken }));
  //     console.log("User info:", user);
  //   } catch (error) {
  //     console.error("Login error");
  //   }
  // };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const idToken = await user.getIdToken();

      // Save user and token to localStorage
      localStorage.setItem("user", JSON.stringify(user)); // Save user object as a string
      localStorage.setItem("token", idToken); // Save token as a string

      // Dispatch user credentials to Redux store
      dispatch(setUserCredentials({ user, token: idToken }));
      dispatch(sendGoogleToken({ token: idToken }));

      // Optionally close login modal or handle other logic
      user && handleClose();

      console.log("User info:", user);
    } catch (error) {
      console.error("Login error", error);
    }
  };

  const handleForgetPasswordModal = (e) => {
    e.preventDefault();
    setForgetPasswordModal(true);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");

    if (storedUser && storedToken) {
      const user = JSON.parse(storedUser);
      dispatch(setUserCredentials({ user, token: storedToken }));
    }
  }, [dispatch]);
  const handleCloseSnackbar = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenedSnackbar(false);
  };
  const [forgetPasswordModal, setForgetPasswordModal] = useState(false);
  const {t}=useTranslation();
  return (
    <div className={styles.modal}>
      <div className={styles.closeBtn} onClick={handleClose}>
        <img src={close} alt="" />
      </div>
      {forgetPasswordModal ? (
        <div className={styles.content}>
          <h1>{t("troubleLoggingIn")}</h1>
          <p
            style={{ maxWidth: "300px", textAlign: "center", fontSize: "14px" }}
          >
            {t("enterEmailToReset")}
          </p>
          <form onSubmit={handleForgetPassword} action="">
            <h4 className={styles.errorMsg}>{errorMsg}</h4>
            <label htmlFor="mail">{t("email")}</label>
            <input
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
              type="email"
            />
            <button type="submit">{t("sendLoginLink")}</button>
          </form>
        </div>
      ) : (
        <div className={styles.content}>
          <h1>{registired ? t("welcomeBack") : t("welcome")}</h1>
          <p>
            {registired
              ? t("loginToExplore")
              : t("signupToExplore")}
          </p>
          {status === "loading" ? (
            <CircularProgress sx={{ marginTop: "50px" }} />
          ) : (
            <>
              <form onSubmit={handleAuthForm} action="">
                <h4 className={styles.errorMsg}>{errorMsg}</h4>
                <label htmlFor="mail">{t("email")}</label>
                <input
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  type="email"
                />
                <label htmlFor="password">{t("password")}</label>
                <input
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  required
                  type="password"
                />
                {!registired && (
                  <>
                    <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
                    <input
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                      required
                      type="password"
                    />
                  </>
                )}
                {registired && (
                  <p onClick={handleForgetPasswordModal}>
                    {t("forgotPassword")}
                  </p>
                )}
                <button type="submit">
                  {registired ? t("login") : t("signup")}
                </button>
              </form>
              <div className={styles.btns}>
                <button onClick={handleGoogleLogin}>
                  <img src={google} alt="" />
                  {t("continueWithGoogle")}
                </button>
              </div>
              <p className={styles.changeText}>
                {registired ? (
                  <>
                    {t("noAccount")}{" "}
                    <span
                      onClick={() => {
                        setErrorMsg("");
                        setRegistered(false);
                      }}
                    >
                      {t("signup")}
                    </span>
                  </>
                ) : (
                  <>
                    {t("alreadyHaveAccount")}{" "}
                    <span
                      onClick={() => {
                        setErrorMsg("");
                        setRegistered(true);
                      }}
                    >
                      {t("login")}
                    </span>
                  </>
                )}{" "}
              </p>
            </>
          )}
        </div>
      )}
      <Snackbar
        open={openedSnackbar}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={3000}
        message={t("passwordResetSuccess")}
      />
    </div>
    // <div className={styles.modal}>
    //   <div className={styles.closeBtn} onClick={handleClose}>
    //     <img src={close} alt="" />
    //   </div>
    //   {forgetPasswordModal ? (
    //     <div className={styles.content}>
    //       <h1>Trouble logging in?</h1>
    //       <p
    //         style={{ maxWidth: "300px", textAlign: "center", fontSize: "14px" }}
    //       >
    //         Enter your email we'll send you a link to get back into your
    //         account.
    //       </p>
    //       <form onSubmit={handleForgetPassword} action="">
    //         <h4 className={styles.errorMsg}>{errorMsg}</h4>
    //         <label htmlFor="mail">Email</label>
    //         <input
    //           onChange={(e) => {
    //             setEmail(e.target.value);
    //           }}
    //           required
    //           type="email"
    //         />

    //         <button type="submit">Send login link</button>
    //       </form>
    //     </div>
    //   ) : (
    //     <div className={styles.content}>
    //       <h1>{registired ? "Welcome back" : "Welcome "}</h1>
    //       <p>
    //         {registired
    //           ? "Log in to continue exploring the best properties."
    //           : "Signup to continue exploring the best properties."}
    //       </p>
    //       {status === "loading" ? (
    //         <CircularProgress sx={{ marginTop: "50px" }} />
    //       ) : (
    //         <>
    //           <form onSubmit={handleAuthForm} action="">
    //             <h4 className={styles.errorMsg}>{errorMsg}</h4>
    //             <label htmlFor="mail">Email</label>
    //             <input
    //               onChange={(e) => {
    //                 setEmail(e.target.value);
    //               }}
    //               required
    //               type="email"
    //             />
    //             <label htmlFor="password">Password</label>
    //             <input
    //               onChange={(e) => {
    //                 setPassword(e.target.value);
    //               }}
    //               required
    //               type="password"
    //             />
    //             {!registired && (
    //               <>
    //                 <label htmlFor="password">Confirm Password</label>
    //                 <input
    //                   onChange={(e) => {
    //                     setConfirmPassword(e.target.value);
    //                   }}
    //                   required
    //                   type="password"
    //                 />
    //               </>
    //             )}
    //             {registired && (
    //               <p onClick={handleForgetPasswordModal}>Forget password?</p>
    //             )}
    //             {registired ? (
    //               <button type="submit">Login</button>
    //             ) : (
    //               <button type="submit">Signup</button>
    //             )}
    //           </form>
    //           <div className={styles.btns}>
    //             <button onClick={handleGoogleLogin}>
    //               {" "}
    //               <img src={google} alt="" />
    //               Continue with Google
    //             </button>
    //             {/* <button>
    //             <img src={facebook} alt="" />
    //             Continue with Facebook
    //           </button> */}
    //           </div>
    //           <p className={styles.changeText}>
    //             {registired ? (
    //               <>
    //                 Don’t have an account yet?{" "}
    //                 <span
    //                   onClick={() => {
    //                     setErrorMsg("");
    //                     setRegistered(false);
    //                   }}
    //                 >
    //                   Signup
    //                 </span>
    //               </>
    //             ) : (
    //               <>
    //                 Already have an account?{" "}
    //                 <span
    //                   onClick={() => {
    //                     setErrorMsg("");
    //                     setRegistered(true);
    //                   }}
    //                 >
    //                   Login
    //                 </span>
    //               </>
    //             )}{" "}
    //           </p>
    //         </>
    //       )}
    //     </div>
    //   )}
    //   <Snackbar
    //     open={openedSnackbar}
    //     onClose={handleClose}
    //     anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    //     autoHideDuration={3000}
    //     message="Password reset email sent"
    //   />
    // </div>
  );
};

export default LoginModal;
